import { addPromotionBackend } from '../../api';
import {
  checkMinBasketPrice,
  isStringNotNull,
  renderErrorMessage,
} from '../../utils';
import store from '../../redux/store';
import { showConnexionModal, showMessageModal } from '../../redux/actions';
import { analyticsEvents } from '../../utils/firebaseAnalytics';
import { logLowLog, logMediumError } from '../../utils/logger';
import { PROMOTION_DELIVERY_FREE } from '../../constants';

export const addPromotion = async (
  setLoadingPromotion: React.Dispatch<React.SetStateAction<boolean>>,
  promoCode: string,
  totalPriceOrder: number
) => {
  const minBasketPrice = await checkMinBasketPrice(promoCode, totalPriceOrder);
  try {
    const { user, userConnected } = store.getState().userReducer;
    const { customerId } = user;
    setLoadingPromotion(true);
    if (isStringNotNull(promoCode)) {
      if (userConnected) {
        logLowLog(`Adding code promo ${promoCode}`);
        const promo = await addPromotionBackend(
          customerId,
          promoCode,
          customerId
        );
        if (promo?.downloadAppLink) {
          store.dispatch(
            showMessageModal(
              `Ce code promotionnel n'est valable que sur notre application mobile que vous pouvez télécharger
                  <a href="${promo.downloadAppLink}" target='_blank' rel='noopener noreferrer'> 
                   ici
                  </a>`
            )
          );
        } else {
          analyticsEvents.logPromoCodeAdded('cartView', 'promoCode');
          const { promotions: shopPromotions } = store.getState().shopReducer;
          const actualPromotion = shopPromotions?.[promoCode];

          const isFreeDelivery = actualPromotion?.type === PROMOTION_DELIVERY_FREE;
          const actualPromoCode = actualPromotion?.promoCode || promoCode;

          let message = '';
          if (isFreeDelivery) {
            message = `Votre code promotionnel "${actualPromoCode}" a bien été ajouté. La livraison vous sera offerte.`;
            if (minBasketPrice) {
              message += ` Pour profiter de cette offre, votre panier doit être supérieur à ${minBasketPrice}€`;
            }
          } else {
            message = `Votre code promotionnel "${actualPromoCode}" a bien été ajouté.`;
            if (minBasketPrice) {
              message += ` Pour profiter de ce code promotionnel, votre panier doit être supérieur à ${minBasketPrice}€`;
            }
          }
          store.dispatch(showMessageModal(message));
        }
      } else {
        store.dispatch(showConnexionModal(true));
      }
    } else {
      store.dispatch(
        showMessageModal(`Vous devez entrer un code promotionnel.`)
      );
    }
    setLoadingPromotion(false);
  } catch (error) {
    const errorMessage = String(error);
    const promotion = store.getState().shopReducer.promotions?.[promoCode];
    setLoadingPromotion(false);
    let message = renderErrorMessage(errorMessage, null);
    if (
      promotion &&
      Object.hasOwn(promotion, 'startedDate') &&
      Object.hasOwn(promotion, 'endedDate')
    ) {
      const validDates = {
        startedDate: promotion.startedDate,
        endedDate: promotion.endedDate,
      };
      message = renderErrorMessage(errorMessage, validDates);
    }
    store.dispatch(showMessageModal(message));
    logMediumError(`Error adding promotion ${error}`);
  }
};
